module.exports = __webpack_public_path__ + "img/ps.4fdba8ff.png";